/*
|--------------------------------------------------------------------------
| Views: Grid
|--------------------------------------------------------------------------
*/
/**
 * Grid
 * @namespace
 */
 __gh__webApp.views.grid = {

 	"getSubView": function(bucket){
	 	var commonJS			= __gh__webApp.common,
			items 					= (bucket.items.main) ? bucket.items.main : {},
	 		commonViewJS		= __gh__webApp.views.common,
			viewName,hasImage;

	 	//Default
		viewName 		= "buckets/grid/default";
		itemCount 		= (bucket.hasAd) ? 5 : 6;
		getItems		= commonViewJS.splitItems(items,itemCount,bucket);

		//Update bucket
		bucket.view.name 	= viewName;
		bucket.items 		= {
			"main"				:getItems.main,
			"moreHeadlines"		:getItems.moreHeadlines
		};
		return bucket;


 	}
};
